import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import WhatsAppFloat from '@/components/WhatsAppFloat';
import { Phone, Mail, MapPin } from 'lucide-react';

const ContactPage = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>İletişim | Aden İklimlendirme</title>
        <meta
          name="description"
          content="Aden İklimlendirme iletişim bilgileri. İzmir genelinde klima, kombi ve beyaz eşya teknik servis hizmeti."
        />
      </Helmet>

      <Navbar />

      {/* HERO */}
      <section className="py-20 md:py-28 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6 text-center">

          <h1 className="text-4xl md:text-5xl font-bold text-navy mb-4">
            Bizimle İletişime Geçin
          </h1>

          <p className="text-lg text-slate-600">
            Servis talepleriniz ve arıza bildirimleriniz için İzmir’in tüm
            ilçelerine 7/24 teknik servis hizmeti sağlıyoruz.
          </p>

        </div>
      </section>

      {/* CONTACT STRIP */}
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">

          <div className="bg-white rounded-xl shadow-sm border border-slate-100 grid md:grid-cols-3 overflow-hidden">

            {/* PHONE */}
            <a
              href="tel:+905063853685"
              onClick={() => {
                if (window.gtag) {
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-17944147746/P41VCLrutvYbEKLut-xC'
                  });
                }
              }}
              className="p-10 text-center hover:bg-slate-50 transition cursor-pointer block"
            >
              <Phone className="mx-auto text-orange mb-4" size={32} />

              <p className="font-semibold text-navy mb-2">
                Telefon
              </p>

              <p className="text-slate-600">
                +90 506 385 36 85
              </p>

              <p className="text-sm text-slate-400 mt-2">
                7/24 Servis Destek
              </p>
            </a>

            {/* MAIL */}
            <a
              href="mailto:info@adeniklimlendirme.com"
              className="p-10 text-center border-x border-slate-100 hover:bg-slate-50 transition cursor-pointer block"
            >
              <Mail className="mx-auto text-orange mb-4" size={32} />

              <p className="font-semibold text-navy mb-2">
                E-posta
              </p>

              <p className="text-slate-600">
                info@adeniklimlendirme.com
              </p>

              <p className="text-sm text-slate-400 mt-2">
                Aynı gün dönüş sağlanır
              </p>
            </a>

            {/* ADDRESS */}
            <a
              href="https://www.google.com/maps?q=RAFET+PAŞA+MAH.+5351/1+SK.+NO:+9+A+BORNOVA+İZMİR"
              target="_blank"
              className="p-10 text-center hover:bg-slate-50 transition cursor-pointer block"
            >
              <MapPin className="mx-auto text-orange mb-4" size={32} />

              <p className="font-semibold text-navy mb-2">
                Adres
              </p>

              <p className="text-slate-600 text-sm leading-relaxed">
                Rafet Paşa Mah. 5351/1 Sk. No: 9/A
                <br />
                Bornova / İzmir
              </p>

              <p className="text-sm text-slate-400 mt-2">
                Yol tarifi almak için tıklayın
              </p>
            </a>

          </div>

        </div>
      </section>

      {/* MAP + INFO */}
      <section className="pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">

          <div className="grid lg:grid-cols-2 gap-12 items-center">

            {/* MAP */}
            <div className="rounded-xl overflow-hidden shadow-sm h-[360px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.108688696497!2d27.194551275806752!3d38.438958373623905!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b96365b1df50e1%3A0x373ce8ea9aa0757f!2sAden%20%C4%B0klimlendirme!5e0!3m2!1str!2str!4v1770887478098!5m2!1str!2str" width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Google Maps"
              ></iframe>
            </div>

            {/* TEXT */}
            <div>

              <h2 className="text-2xl md:text-3xl font-bold text-navy mb-4">
                İzmir Geneline Servis
              </h2>

              <p className="text-slate-600 leading-relaxed">
                Aden İklimlendirme olarak İzmir’in tüm ilçelerine aynı gün
                teknik servis hizmeti sağlıyoruz. Klima, kombi ve beyaz eşya
                arızalarınız için hızlı, garantili ve profesyonel çözümler
                sunuyoruz.
              </p>

            </div>

          </div>

        </div>
      </section>

      {/* CTA */}
      <section className="bg-navy py-16">
        <div className="max-w-5xl mx-auto px-6 text-center text-white">

          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Hemen Servis Talebi Oluşturun
          </h3>

          <p className="text-slate-300 mb-8">
            Aynı gün servis için bizi arayın veya WhatsApp üzerinden yazın.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">

            <a
              href="tel:+905063853685"
              class="
bg-white
text-[#00205B]
px-7 py-3.5
rounded-lg
font-semibold
border border-[#00205B]
transition-all duration-300
hover:-translate-y-0.5
hover:shadow-lg
hover:shadow-[#00205B]/30
"            >
              Hemen Ara
            </a>

            <a
              href="https://wa.me/905063853685"
              target="_blank"
              className="btn-secondary"
            >
              WhatsApp’tan Yaz
            </a>

          </div>

        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ContactPage;
